import { useContext } from 'react';

import { SignUpActionContext } from '../context/actions/SignUpActionContext';

export const useSignUpActions = () => useContext(SignUpActionContext);
